var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-view',{attrs:{"title":"認証エラー"}},[_vm._v("\n  ログインできませんでした。ページを閉じて再度お試しください。\n")])}
var staticRenderFns = []

export { render, staticRenderFns }